export default "__VITE_ASSET__CkFJgSXN__"